export default __webpack_public_path__ + "static/media/avt.2be2c9ce.png";